import styles from './styles/commontips.module.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { message } from 'antd';
import { useState } from 'react';

const CommonTips = () => {
  const { state } = useLocation();
  const Navigate = useNavigate();
  const [msg, setMsg] = useState('');
  useEffect(() => {
    if (state && state.message) {
      setMsg(state.message);
    } else {
      message.warning('Message is Invalid');
      Navigate(-1);
    }
  }, [state]);
  return (
    <div className={styles['common-tips-container']}>
      <span className={styles['tips']}>{msg}</span>
      <span
        className={styles['back']}
        onClick={() => {
          Navigate(-1);
        }}
      >
        Back
      </span>
    </div>
  );
};

export default CommonTips;
